(function () {
    "use strict";

    angular.module("app.sales").controller("SalesPaymentController", SalesPaymentController);

    SalesPaymentController.$inject = [
        "$scope",
        "$timeout",
        "CartService",
        "GeneralService",
        "CustomerAddressService",
        "SalesPaymentService"
    ];

    function SalesPaymentController(
        $scope,
        $timeout,
        CartService,
        GeneralService,
        CustomerAddressService,
        SalesPaymentService
    ) {
        var vm = this;
        vm.success = false;
        vm.newCustomerAddress = {};
        vm.newGuestCustomerAddress = {
            MessageStatus: true,
            AddressType: "INDIVIDUAL"
        };
        vm.frmUserAddressSave = { AddressType: "INDIVIDUAL" };
        vm.isAuthenticated = false;
        vm.pay = { CreditCardPaymentOption: "00" };
        vm.loading = false;
        vm.tabIndex = 0;
        vm.salesOrderType = "sales";
        vm.tabOneDisable = false;
        vm.tabTwoDisable = false;
        vm.accorionStatus = [];
        vm.accorionStatus["_creditcard"] = { open: true };

        function activate() {
            GeneralService.getStateProvince().then(function (response) {
                vm.getStateProvince = response.data;
            });

            GeneralService.getCountry().then(function (response) {
                vm.getCountry = response.data;
            });

            $scope.$watch("vm.pay.Total", function (value) {
                if (vm.cart && vm.salesOrderType === "direct") {
                    vm.cart.TotalWithDiscount = value || 0;
                }
            });

            $scope.$watch("vm.pay.CreditCardPaymentOption", function (value) {
                if (value) {
                    var valueArray = value.split("_");
                    if (valueArray.length > 1) {
                        vm.pay.Installment = valueArray[0];
                        vm.pay.BankId = valueArray[1];
                        vm.pay.InstallmentId = valueArray[2];
                    } else {
                        vm.pay.Installment = "00";
                        vm.pay.BankId = vm.DefaultCheckoutBank ? vm.DefaultCheckoutBank.Id : "";
                    }
                }
            });

            $scope.$watch("vm.pay.CardNumber", function (newValue, oldValue) {
                if (newValue) {
                    var newbin = (newValue || "").replace(" ", "").substring(0, 6);
                    var oldbin = (oldValue || "").replace(" ", "").substring(0, 6);
                    if (newbin !== oldbin && newbin.length > 5) {
                        SalesPaymentService.getBanktype(newbin).then(function (data) {
                            vm.ActiveBank = data;
                            vm.ActiveBank.Bank = vm.banks.find(function (bank) {
                                return bank.Id === vm.ActiveBank.BankId;
                            });
                            if (vm.ActiveBank.Bank) {
                                var oneInstallment = vm.ActiveBank.Bank.Installment.find(function (item) {
                                    return item.BankInstallment == 1;
                                });
                                vm.pay.CreditCardPaymentOption =
                                    "1_" + vm.ActiveBank.Bank.Id + (oneInstallment ? "_" + oneInstallment.Id : "");
                                vm.pay.ThreeDType =
                                    vm.ActiveBank.Bank.ThreeDType === null ? true : vm.ActiveBank.Bank.ThreeDType;
                            } else {
                                vm.pay.CreditCardPaymentOption = "1_" + vm.defaultCheckoutBank.Id;
                                vm.pay.ThreeDType =
                                    vm.defaultCheckoutBank.ThreeDType === null ? true : vm.defaultCheckoutBank.ThreeDType;
                            }
                        });
                    }
                }
            });

            $scope.$watch("vm.pay.BankId", function (newValue) {
                if (vm.banks) {
                    var bank = vm.banks.find(function (item) {
                        return item.Id === newValue;
                    });
                    vm.selectedBank = bank;
                    if (vm.cart && vm.cart.Id) {
                        vm.cart.SelectedBankId = vm.selectedBank.Id;
                        vm.updateCart();
                    }
                }
            });

            $scope.$watchCollection("[vm.deliveryAddress.Id,vm.billAddress.Id]", function (newValue, oldValue) {
                if (vm.cart) {
                    vm.cart.InvoiceAddressId = vm.deliveryAddress != null ? vm.deliveryAddress.Id : null;
                    vm.cart.DeliveryAddressId = vm.billAddress != null ? vm.billAddress.Id : null;
                    vm.updateCart();
                }
            });

            $("#paymentModal").on("hidden.bs.modal", function (e) {
                $("#loading").attr("style", "display:flex !important");
                location.href = "/Checkout/Checkout";
            });

            $timeout(function () {
                if (vm.salesOrderType === "direct") {
                    vm.cart = { TotalWithDiscount: 0.0 };
                    vm.pay.Total = 0.0;
                    vm.tabIndex = 0;
                    window.scroll(0, 0);
                    vm.loading = false;
                    vm.getBanks();
                } else if (vm.salesOrderType === "debt") {
                    vm.cart = { TotalWithDiscount: generalVariable.debtTotal };
                    vm.pay.Total = generalVariable.debtTotal;
                    vm.pay.Description = generalVariable.debtDescription;
                    vm.tabIndex = 0;
                    window.scroll(0, 0);
                    vm.loading = false;
                    vm.getBanks();
                } else {
                    vm.getCustomerAddresses();

                    if (vm.isAuthenticated) {
                        vm.tabOneDisable = true;
                        vm.tabIndex = 1;
                        window.scroll(0, 0);
                        vm.loading = false;
                    }
                    CartService.getCart().then(function (data) {
                        vm.cart = data;
                        if (vm.isAuthenticated && vm.cart.DeliveryAddressId) {
                            vm.tabIndex = 2;
                        }
                        vm.getBanks();
                    });
                }
            });
        }

        vm.getBanks = function () {
            GeneralService.GetBanks().then(function (data) {
                vm.banks = data.data.filter(function (item) {
                    return item.Active === true;
                });
                vm.checkoutBanks = vm.banks.filter(function (item) {
                    return item.UseCheckout;
                });
                vm.otherBanks = vm.banks.filter(function (item) {
                    return !item.UseCheckout;
                });
                vm.transferEFTBanks = data.data.filter(function (item) {
                    return item.TransferEFT && item.UseCheckout;
                });
                vm.defaultCheckoutBank = vm.banks.find(function (item) {
                    return item.Default;
                });
                if (!vm.defaultCheckoutBank.UseCheckout) {
                    vm.accorionStatus["_creditcard"] = { open: false };
                    vm.accorionStatus[vm.defaultCheckoutBank.Id] = {
                        open: true
                    };
                }
                vm.pay.ThreeDType = vm.defaultCheckoutBank.ThreeDType === null ? true : vm.defaultCheckoutBank.ThreeDType;
                vm.pay.BankId = vm.defaultCheckoutBank.Id;
                vm.pay.CreditCardPaymentOption = "1_" + vm.defaultCheckoutBank.Id;
            });
        };

        vm.checkout = function () {
            vm.loading = true;
            var formData = $('[name="vm.frmPayment"]').serialize();
            SalesPaymentService.payment(formData).then(function (data) {
                vm.loading = false;
                var iframe = document.createElement("iframe");
                iframe.src = "data:text/html;charset=utf-8," + encodeURI(data);
                document.getElementById("paymentModalBody").appendChild(iframe);
                $("#paymentModal")
                    .addClass(vm.selectedBank.NormalizedName)
                    .modal("show");
            });
        };

        vm.selectBank = function (bank, customid) {
            if (customid) {
                vm.pay.BankId = vm.defaultCheckoutBank.Id;
                vm.accorionStatus[customid] = { open: true };
            } else {
                vm.pay.BankId = bank.Id;
                vm.accorionStatus[bank.Id] = { open: true };
            }
        };

        vm.updateCart = function () {
            vm.loading = true;
            CartService.updateCart(vm.cart).then(function (data) {
                vm.cart = data;
                vm.loading = false;
            });
        };

        vm.getCustomerAddresses = function () {
            vm.loading = true;
            CustomerAddressService.getCustomerAddresses().then(function (response) {
                if (response && response.length > 0) {
                    vm.customerAddresses = response;
                    vm.newGuestCustomerAddress = response[0];
                    //if (vm.isAuthenticated) {
                    //}
                    vm.customer = response.Customer;
                    vm.tabOneDisable = true;
                    vm.tabIndex = 1;
                } else {
                    vm.newAddress = true;
                }
                vm.loading = false;
            });
        };

        vm.goPaymentTab = function () {
            if (vm.isAuthenticated) {
                vm.tabIndex = 2;
                window.scroll(0, 0);
            } else {
                vm.saveGuestUserAddress();
            }
        };

        vm.goAddressTab = function () {
            vm.tabIndex = 1;
            window.scroll(0, 0);
        };

        vm.saveGuestEmail = function () {
            vm.loading = true;
            if (vm.frmGuestUserEmail.$valid) {
                CustomerAddressService.addCustomerAddressWithUser(vm.newGuestCustomerAddress).then(
                    function (address) {
                        vm.newGuestCustomerAddress = address;
                        vm.tabOneDisable = true;
                        vm.tabIndex = 1;
                        window.scroll(0, 0);
                        vm.loading = false;
                    },
                    function (response) {
                        vm.loading = false;
                        vm.saveGuestEmailMessage = response.data.Message;
                    }
                );
            }
        };

        activate();

        vm.getStateProvinceChange = function (StateProvinceId) {
            if (StateProvinceId) {
                GeneralService.getDistrict(StateProvinceId).then(function (response) {
                    vm.getDistrict = response.data;
                });
            }
        };

        vm.saveUserAddress = function () {
            if (vm.frmUserAddressSave.$valid) {
                CustomerAddressService.addCustomerAddress(vm.newCustomerAddress).then(function () {
                    vm.newAddress = false;
                    vm.newCustomerAddress = {};
                    vm.getCustomerAddresses();
                });
            }
        };

        vm.saveGuestUserAddress = function () {
            vm.loading = true;
            if (vm.frmGuestUserAddressSave.$valid) {
                CustomerAddressService.addCustomerAddressWithUser(vm.newGuestCustomerAddress).then(function (address) {
                    vm.deliveryAddress = address;
                    vm.billAddress = address;
                    vm.tabIndex = 2;
                    window.scroll(0, 0);
                    vm.loading = false;
                });
            }
        };

        vm.sec = function (delAddress) {
            if (vm.checked) {
                vm.deliveryAddress = delAddress;
                vm.billAddress = delAddress;
            } else {
                vm.deliveryAddress = delAddress;
                vm.active = delAddress;
            }
        };

        vm.billSec = function (bilAddress) {
            vm.billAddress = bilAddress;
            vm.active = bilAddress;
        };

        vm.billdel = function () {
            if (vm.checked) {
                vm.billAddress = vm.deliveryAddress;
            } else {
                vm.billAddress = null;
            }
        };

        vm.prepareEdit = function (index) {
            vm.editAddress = true;
            vm.editAddressIndex = index;
            vm.getStateProvinceChange(vm.customerAddresses[vm.editAddressIndex].StateProvinceId);
        };

        vm.editUserAddress = function (editAddressIndex) {
            vm.loading = true;
            if (vm.frmUserAddressEdit.$valid) {
                CustomerAddressService.editCustomerAddress(vm.customerAddresses[editAddressIndex]).then(function () {
                    vm.editAddress = false;
                    vm.newAddress = false;
                    vm.editAddressIndex = null;
                    vm.getCustomerAddresses();
                });
            }
        };

        vm.deleteUserAddress = function (index) {
            if (confirm("Silmek istediğinize emin misiniz?")) {
                vm.loading = true;
                CustomerAddressService.deleteCustomerAddress(vm.customerAddresses[index]).then(function (response) {
                    response.data.splice(vm.customerAddresses[index]);
                    vm.loading = false;
                });
            }
        };

        //// Utils  ///////////////

        vm.getFraction = function (x) {
            return (x - Math.floor(x)).toFixed(2).replace("0.", "");
        };

        vm.getDecimal = function (x) {
            return Math.floor(x);
        };

        vm.getInstallmentWithBankInstallment = function (installmentList, bankInstallment) {
            return installmentList.find(function (x) {
                return x.BankInstallment == bankInstallment;
            });
        };

        vm.getTotalInstallmentAverageDay = function (bank) {
            var dd = vm.pay.Total / vm.general.AmountPassedByCreditCard;
            var total = 0;
            for (let i = 2; i < bank.Installment.length; i++) {
                const item = bank.Installment[i];
                total +=
                    dd * bank.CollectionDaysInstallmentFirstPaymentDay +
                    bank.CollectionDaysInstallmentRepaymentPeriod * (i - 1);
            }
            return total / vm.pay.Total;
        };
    }
})();
